import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, getToken, setToken } from "@/lib/api";

const AuthContext = createContext({ user: null, loading: true });

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const apply = useCallback((u) => {
    setUser(u);
    window.__attireUserId = u?.id || null;
  }, []);

  useEffect(() => {
    const boot = async () => {
      if (!getToken()) { setLoading(false); return; }
      try { apply(await api.me()); } catch { setToken(null); apply(null); }
      finally { setLoading(false); }
    };
    boot();
    const onUnauth = () => { setToken(null); apply(null); };
    window.addEventListener("attire:unauthorized", onUnauth);
    return () => window.removeEventListener("attire:unauthorized", onUnauth);
  }, [apply]);

  const login = async (email, password) => {
    // typing "demo" as the email opens the shared demo closet (no password)
    const r = String(email || "").trim().toLowerCase() === "demo" ? await api.demoLogin() : await api.login({ email, password });
    setToken(r.token); apply(r.user);
    return r;
  };
  const demoLogin = async () => {
    const r = await api.demoLogin();
    setToken(r.token); apply(r.user);
    return r;
  };
  const register = async (payload) => {
    const r = await api.register(payload);
    setToken(r.token); apply(r.user);
    return r;
  };
  const logout = async () => {
    try { await api.logout(); } catch { /* ignore */ }
    setToken(null); apply(null);
  };
  const refresh = async () => { try { apply(await api.me()); } catch { /* ignore */ } };

  return <AuthContext.Provider value={{ user, loading, login, register, logout, refresh, demoLogin }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
